import { Controller } from "stimulus";
import { copyToClipboard } from "../../util/copy_to_clipboard";
import { getCSRFToken } from "../../util";
import { GeckoPrimerInputError } from "../../events";

export default class extends Controller {
  static targets = ["address", "buttonIcon", "emailInput"];

  copyDonationAddress(e) {
    const textTarget = e.currentTarget.closest("div[x-ref='container']").querySelector("input");
    const iconTarget = e.currentTarget.querySelector("i");

    copyToClipboard(textTarget, iconTarget);
  }

  toggleFooterGroup(e) {
    const footerGroup = e.currentTarget;
    const footerGroupLinks = document.getElementById(`${footerGroup.id}-group`);
    const toggle = footerGroup.querySelector("i");

    toggle.classList.toggle("fa-plus");
    toggle.classList.toggle("fa-minus");
    footerGroup.classList.toggle("tw-border-b")
    footerGroupLinks.classList.toggle("tw-border-b");
    footerGroupLinks.classList.toggle("tw-pb-4");
    footerGroupLinks.classList.toggle("tw-h-0");
  }

  subscribeNewsletter(e) {
    e.preventDefault();

    const buttonTarget = e.currentTarget;
    const previousText = buttonTarget.innerHTML;
    buttonTarget.disabled = true;

    let params = {
      email: this.emailInputTarget.value,
      campaignId: e.currentTarget.dataset.campaignId
    };

    fetch("/newsletter/subscribe", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCSRFToken()
      },
      body: JSON.stringify(params)
    })
      .then(response => {
        // TODO: Remove if not required. Seems legacy.
        window._vis_opt_queue = window._vis_opt_queue || [];
        window._vis_opt_queue.push(function() { _vis_opt_goal_conversion(200); });

        return response.json();
      })
      .then(data => {
        if (data.httpStatus === 202) {
          Toaster.toast(I18n.t("newsletter.success"));
          return;
        }

        let errorMessage;
        if (data.httpStatus === 406) {
          errorMessage = "Invalid campaign ID. Please try later."
        } else if (data.context.length) {
          errorMessage = data.context[0]["errorDescription"];
        } else {
          errorMessage = data.message;
        }

        this.emailInputTarget.dispatchEvent(GeckoPrimerInputError(true, errorMessage))
      })
      .catch(() => {
        this.emailInputTarget.dispatchEvent(GeckoPrimerInputError(true, "Unknown error. Please try later."))
      })
      .finally(() => {
        buttonTarget.disabled = false;
      });
  }
}
